import { FC } from 'react';
import columns from './columns';
import subColumns from './columns/subColumns';
import DataCollapseTable from './components/DataCollapseTable';
import useGetFastDeals from '../../hooks/useGetFastDeals';

type TFastDealsListFC = {
  config: {
    pageSize: number;
    defaultFilter: object;
  };
};

const FastDealsList: FC<TFastDealsListFC> = ({ config }) => {
  const { pageSize, defaultFilter } = config;

  const { isFetching, data, fetchNextPage, hasNextPage, convertDataForGrid } =
    useGetFastDeals({ pageSize, defaultFilter });
  const convertedData = convertDataForGrid(data);

  return (
    <DataCollapseTable
      columns={columns}
      subColumns={subColumns}
      data={convertedData}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage || false}
      isFetching={isFetching}
    />
  );
};

export default FastDealsList;
